// removed by extract-text-webpack-plugin
module.exports = {"Orders":"Orders__Orders__1eUYF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Orders/Orders.css
// module id = 188
// module chunks = 0